const Validators = {
    isEmail: (str) => /^[\w.-]+@[\w.-]+\.\w{2,6}$/.test(str),
    isNotEmpty: (str) => /\S+/.test(str),
    isNumber: (str) => /^\d+$/.test(str),
    isSame: (a, b) => a === b,
    isURL: (str) => {
        const pattern = new RegExp('^(https?:\\/\\/)?' +
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*).)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$', 'i');
        return pattern.test(str);
    },
    isPhoneNumber: (str) => /^(1\s?|1)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4,7})$/.test(str),
};
export default Validators;
